
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M125.351 169.363c-2.918 2.898-7.709 2.898-10.627 0l-67.52-67.04A7.387 7.387 0 0145 97.047c0-1.964.763-3.845 2.204-5.276 2.918-2.897 7.708-2.897 10.627 0l62.146 61.705 62.207-61.764c2.919-2.898 7.709-2.898 10.627 0 2.918 2.897 2.919 7.652.001 10.55l-67.461 67.101z"}})])
          )
        }
      }
    